import { Box, Theme } from '@mui/material';
import { useSelector } from 'react-redux';

import { Button } from '@/components';
import { urls } from '@/constants';
import { AnalyticsService, CPA_BUTTON_NAME } from '@/services';
import { selectSessionUserId } from '@/store';
import { CPACanadaEpisode } from '@/types';

interface CPAHeaderProps {
  cpaCanadaContent?: CPACanadaEpisode | null;
}

export const CPAHeader = ({ cpaCanadaContent }: CPAHeaderProps) => {
  const isAnonymous = !useSelector(selectSessionUserId);
  const headerButtonText = isAnonymous ? 'Claim 5 Free Hours' : 'Back to LumiQ';

  return (
    <Box sx={styles.container}>
      <Box sx={styles.leftContainer}>
        <Box
          component="img"
          alt=""
          src={cpaCanadaContent?.header.logoCpa}
          sx={styles.cpacanadalogo}
          onClick={() => {
            AnalyticsService.buttonClick({ name: CPA_BUTTON_NAME.CANADA_LOGO });
            window.open('/', '_self');
          }}
        />
      </Box>

      <Box sx={styles.rightContainer}>
        <Button
          label={headerButtonText}
          skinny={false}
          onClick={() => {
            AnalyticsService.buttonClick(
              isAnonymous
                ? { name: CPA_BUTTON_NAME.SIGN_UP }
                : { name: CPA_BUTTON_NAME.BACK_TO_LUMIQ },
            );

            const url = isAnonymous
              ? urls.appBase + cpaCanadaContent?.header.signupUrl
              : '/';
            window.open(url, '_self');
          }}
        />
      </Box>
    </Box>
  );
};

const styles = {
  container: (theme: Theme) => ({
    mt: 4,
    mb: 4,
    height: theme.dimensions.header.height,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      height: 90,
      ml: 4,
      mr: 4,
    },
  }),
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
  },
  rightContainer: (theme: Theme) => ({
    alignSelf: 'center',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }),
  cpacanadalogo: (theme: Theme) => ({
    height: 70,
    width: 323,
    [theme.breakpoints.down('xs')]: {
      width: 205,
      height: 47,
    },
  }),
};
